// extracted by mini-css-extract-plugin
export default {"rssCard":"RSSSourceCard_rssCard__tFA5S"};